export const postings = [
  {label: 'All Postings', value: '0'},
  {label: '< 3 Days', value: 3},
  {label: 'Last Week', value: 7},
  {label: 'Two Weeks', value: 15},
  {label: 'Last Month', value: 30},
];

export const postingsJobfeed = [
  {label: 'All Postings', value: '0'},
  {label: '< 3 days', value: 3},
  {label: 'Last 1 Week', value: 7},
  {label: 'Last 2 Weeks', value: 15},
  {label: 'Last 1 Month', value: 30},
];

export const postingsHirist = [
  {label: 'All Postings', value: '0'},
  {label: '< 3 Days', value: 3},
  {label: 'Last 1 Week', value: 7},
  {label: 'Last 2 Weeks', value: 15},
  {label: 'Last 1 Month', value: 30},
  {label: 'Last 3 Months', value: 90},
];
export const searchTypes = [
  {
    label: 'Jobs',
    value: 0,
  },
  {
    label: 'Companies',
    value: 1,
  },
  {
    label: 'Courses',
    value: 2,
  },
];

export const categories = [
  {
    label: 'All Categories',
    value: '0',
  },
  {
    label: 'Banking & Finance',
    value: 13,
  },
  {
    label: 'Sales & Marketing',
    value: 14,
  },
  {
    label: 'Consulting',
    value: 16,
  },
  {
    label: 'HR & IR',
    value: 17,
  },
  {
    label: 'IT & Systems',
    value: 15,
  },
  {
    label: 'SCM & Operations',
    value: 19,
  },
  {
    label: 'Legal',
    value: 21,
  },
  {
    label: 'BPO',
    value: 22,
  },
  {
    label: 'GenAI',
    value: 25,
  },
];
export const categoryOptions = [
  {value: 0, label: 'Category'},
  {value: 7, label: 'Data Analytics & BI'},
  {value: 5, label: 'Mobile Applications'},
  {value: 8, label: 'DevOps/SRE'},
  {value: 2, label: 'Frontend Development'},
  {value: 1, label: 'Backend Development'},
  {value: 9, label: 'Emerging Technologies'},
  {value: 10, label: 'UI & Design'},
  {value: 11, label: 'Quality Assurance'},
  {value: 12, label: 'Product Management'},
  {value: 6, label: 'Platform Engineering/SAP/Oracle'},
  {value: 4, label: 'Semiconductor/VLSI/EDA'},
  {value: 13, label: 'Business Analysis and Project Management'},
  {value: 14, label: 'AI/ML'},
  {value: 15, label: 'Data Engineering'},
  {value: 16, label: 'Full Stack'},
  {value: 17, label: 'CyberSecurity'},
  {value: 3, label: 'Others'},
];

export const HIRIST_FUNCTIONAL_AREAS = [
  {value: 1, label: 'Software Developer'},
  {value: 2, label: 'Technical / Solution Architect'},
  {value: 3, label: 'Project Management'},
  {value: 4, label: 'Product Management'},
  {value: 5, label: 'QA & Testing'},
  {value: 6, label: 'Design / Graphics'},
  {value: 8, label: 'Systems Administration'},
  {value: 9, label: 'Network Administration'},
  {value: 10, label: 'Database Admin / Development'},
  {value: 11, label: 'Technical / Production Support'},
  {value: 12, label: 'Technical Writing'},
  {value: 13, label: 'Data Analysis / Business Analysis'},
  {value: 14, label: 'Senior Management'},
  {value: 15, label: 'Other'},
  {value: 16, label: 'Backend Development'},
  {value: 17, label: 'Frontend Development'},
  {value: 18, label: 'Full-Stack Development'},
  {value: 19, label: 'Mobile Development - Android'},
  {value: 20, label: 'Mobile Development - iOS'},
  {value: 21, label: 'Mobile Development - Hybrid/Native'},
  {value: 22, label: 'DevOps / Cloud'},
  {value: 23, label: 'Site Reliability Engineering'},
  {value: 24, label: 'Big Data / Data Warehousing / ETL'},
  {value: 25, label: 'Embedded / Kernel Development'},
  {value: 26, label: 'Other Software Development'},
  {value: 27, label: 'Data Science'},
  {value: 28, label: 'Data Mining / Analysis'},
  {value: 29, label: 'Data Engineering'},
  {value: 30, label: 'ML / DL Engineering'},
  {value: 31, label: 'ML / DL / AI Research'},
  {value: 32, label: 'Engineering Management'},
  {value: 33, label: 'Release Management'},
  {value: 34, label: 'Program Management'},
  {value: 35, label: 'UI / UX Design'},
  {value: 36, label: 'Product Design'},
  {value: 37, label: 'UX Architect'},
  {value: 38, label: 'Web Design'},
  {value: 39, label: 'Graphic Design / Animation'},
  {value: 40, label: 'Illustrator'},
  {value: 41, label: 'Interaction Design'},
  {value: 42, label: 'AR / VR Design'},
  {value: 43, label: 'User Researcher'},
  {value: 44, label: 'Other Design'},
  {value: 45, label: 'Blockchain'},
  {value: 46, label: 'IoT'},
  {value: 47, label: 'Computer Vision'},
  {value: 48, label: 'Cloud Computing'},
  {value: 49, label: 'AR / VR'},
  {value: 50, label: 'Cyber Security'},
  {value: 51, label: 'Functional / Technical Consulting'},
  {value: 52, label: 'IT Management / IT Support'},
  {value: 53, label: 'IT Security'},
  {value: 54, label: 'IT Infrastructure Services'},
  {value: 55, label: 'Networking & Wireless'},
];

export const experienceOptionsHirist = [
  {value: 1, label: 'Any Exp. Level', minExp: 0, maxExp: 30},
  {value: 2, label: '0 - 1 yrs', minExp: 0, maxExp: 1},
  {value: 3, label: '2 - 3 yrs', minExp: 2, maxExp: 3},
  {value: 4, label: '4 - 6 yrs', minExp: 4, maxExp: 6},
  {value: 5, label: '7 - 10 yrs', minExp: 7, maxExp: 10},
  {value: 6, label: '11 - 15 yrs', minExp: 11, maxExp: 15},
  {value: 7, label: '16 - 20 yrs', minExp: 16, maxExp: 20},
  {value: 8, label: '21 - 25 yrs', minExp: 21, maxExp: 25},
  {value: 9, label: '26+ yrs', minExp: 26, maxExp: 30},
];
export const PopularTags = [
  {
    id: 0,
    name: 'Popular',
    alias: 'Popular for job',
    tags: [
      {
        id: '2023',
        name: 'Data Scientist',
        alias: 'Data Science',
        key: 'Data Scientist',
      },
      {
        id: '9',
        name: 'Python',
        alias: 'Python',
        key: 'Python',
      },
      {
        id: '203',
        name: 'Machine Learning',
        alias: 'Machine Learning',
        key: 'Machine Learning',
      },
      {
        id: 0,
        name: 'Android IOS',
        alias: 'Android/IOS',
        searchString: 'Android iOS',
      },
      {
        id: 0,
        name: 'Angular React JS',
        alias: 'Angular /React .JS',
        searchString: 'Angular React JS',
      },
      {
        id: '2696',
        name: 'MERN',
        alias: 'MERN',
        key: 'MERN Stack',
      },
      {
        id: 0,
        name: 'UX Designer',
        alias: 'UX',
        searchString: 'UX Designer',
      },
      {
        id: '30',
        name: 'Project Manager',
        alias: 'Project Manager',
        key: 'Project Management',
      },
      {
        id: '28',
        name: 'Product Manager',
        alias: 'Product manager',
        key: 'Product Management',
      },
      {
        id: '1612',
        name: 'Full Stack',
        alias: 'Full Stack',
        key: 'Full Stack',
      },
      {
        id: '17730',
        name: 'Data Analyst',
        alias: 'Data Analyst',
        key: 'Data Analyst',
      },
      {
        id: 0,
        name: 'Backend Developer Jobs',
        alias: 'Backend',
        searchString: 'Backend Developer',
      },
      {
        id: 0,
        name: 'Fintech Jobs',
        alias: 'Fintech',
      },

      {
        id: 0,
        name: 'Startup Jobs',
        alias: 'Startup',
      },
      {
        id: 0,
        name: 'Frontend Jobs',
        alias: 'Frontend',
      },
    ],
    icon: 'icon-others',
    meta: '',
  },
];

export const methodOptions = [
  {value: 1, label: 'Method'},
  {value: 2, label: 'Online'},
  {value: 3, label: 'Blended'},
  {value: 4, label: 'Classroom'},
];

// export const experiences = [
//   {label: 'All Exp. Level', value: 1},
//   {label: '0 – 1 Yrs', value: 2},
//   {label: '2 – 3 Yrs', value: 3},
//   {label: '4 – 6 Yrs', value: 4},
//   {label: '7 – 10 Yrs', value: 5},
//   {label: '11 – 15 Yrs', value: 6},
//   {label: '16 – 20 Yrs', value: 7},
//   {label: '21 - 25 Yrs', value: 8},
//   {label: '25+ yrs', value: 9},
// ];

// export const experiences = [
//   {label: 'All Exp. Level', value: 1},
//   {label: '1 - 3 years', value: 2},
//   {label: '4 - 6 years', value: 3},
//   {label: '7 - 10 years', value: 4},
//   {label: '11 - 15 years', value: 5},
//   {label: '15+ years', value: 6},
// ];

export const experiences = [
  // {label: 'All Exp. Level', value: 1},
  {label: '0 – 1 Yrs', value: 2},
  {label: '2 – 3 Yrs', value: 3},
  {label: '4 – 6 Yrs', value: 4},
  {label: '7 – 10 Yrs', value: 5},
  {label: '11 – 15 Yrs', value: 6},
  {label: '16 – 20 Yrs', value: 7},
  {label: '21 - 25 Yrs', value: 8},
  {label: '25+ yrs', value: 9},
];

export const experiencesHirist = [
  {value: 0, label: 'Any Exp. Level'},
  {value: 1, label: '0 - 1 yrs'},
  {value: 2, label: '2 - 3 yrs'},
  {value: 3, label: '4 - 6 yrs'},
  {value: 4, label: '7 - 10 yrs'},
  {value: 5, label: '11 - 15 yrs'},
  {value: 6, label: '16 - 20 yrs'},
  {value: 7, label: '21 - 25 yrs'},
  {value: 8, label: '26+ yrs'},
];

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

export const locations = [
  {
    label: 'Metros',
    value: 87,
    selected: [1, 36, 41, 40, 37, 38, 2, 5, 3, 7, 4, 6, 54, 78, 39],
  },
  {
    label: isAppIimjobs
      ? 'Anywhere in India/Multiple Locations'
      : 'Anywhere in India',
    value: 88,
    selected: [
      87, 1, 36, 41, 40, 37, 38, 2, 5, 3, 7, 4, 6, 54, 78, 53, 45, 34, 79, 65,
      19, 14, 64, 70, 84, 86, 58, 55, 13, 39, 8, 77, 12, 57, 16, 71, 72, 11, 46,
      43, 42, 63, 20, 52, 31, 17, 60, 48, 83, 9, 10, 73, 66, 67, 68, 18, 50, 47,
      61, 85, 15, 74, 33, 80, 62, 49, 44, 32, 35, 69, 75, 51, 21, 59, 56, 81,
      76, 82, 127, 123, 121, 130, 124, 125, 122, 128, 126, 129, 131, 133, 134,
      135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149,
      150, 151, 152, 153, 158, 160, 161, 162, 163,
    ],
  },
  {
    label: 'Overseas/International',
    value: 89,
    selected: [
      100, 109, 26, 90, 107, 105, 108, 106, 98, 91, 113, 112, 28, 30, 103, 92,
      114, 93, 95, 27, 25, 97, 115, 104, 94, 96, 110, 120, 99, 102, 101, 24,
      117, 111, 116, 23, 22, 119, 118, 165, 166, 167, 168, 169, 170,
    ],
  },
  {
    label: 'Abu Dhabi',
    value: 100,
    selected: [],
  },
  {
    label: 'Afghanistan',
    value: 109,
    selected: [],
  },
  {
    label: 'Africa',
    value: 26,
    selected: [],
  },
  {
    label: 'Agra',
    value: 136,
    selected: [],
  },
  {
    label: 'Ahmedabad',
    value: 53,
    selected: [],
  },
  {
    label: 'Amritsar',
    value: 45,
    selected: [],
  },
  {
    label: 'Andaman and Nicobar Island',
    value: 162,
    selected: [],
  },
  {
    label: 'Andhra Pradesh',
    value: 34,
    selected: [],
  },
  {
    label: 'Arunachal Pradesh',
    value: 127,
    selected: [],
  },
  {
    label: 'Assam',
    value: 123,
    selected: [],
  },
  {
    label: 'Aurangabad',
    value: 79,
    selected: [],
  },
  {
    label: 'Australia',
    value: 165,
    selected: [],
  },
  {
    label: 'Baddi',
    value: 140,
    selected: [],
  },
  {
    label: 'Bahrain',
    value: 90,
    selected: [],
  },
  {
    label: 'Bangalore',
    value: 3,
    selected: [],
  },
  {
    label: 'Bangladesh',
    value: 107,
    selected: [],
  },
  {
    label: 'Bhopal',
    value: 121,
    selected: [],
  },
  {
    label: 'Bhubaneshwar',
    value: 65,
    selected: [],
  },
  {
    label: 'Bhutan',
    value: 105,
    selected: [],
  },
  {
    label: 'Bihar',
    value: 19,
    selected: [],
  },
  {
    label: 'Canada',
    value: 167,
    selected: [],
  },
  {
    label: 'Chandigarh',
    value: 14,
    selected: [],
  },
  {
    label: 'Chennai',
    value: 6,
    selected: [],
  },
  {
    label: 'Chhattisgarh',
    value: 64,
    selected: [],
  },
  {
    label: 'China',
    value: 108,
    selected: [],
  },
  {
    label: 'Cochin/Kochi',
    value: 70,
    selected: [],
  },
  {
    label: 'Coimbatore',
    value: 84,
    selected: [],
  },
  {
    label: 'Cuttack',
    value: 86,
    selected: [],
  },
  {
    label: 'Dadra and Nagar Haveli',
    value: 161,
    selected: [],
  },
  {
    label: 'Daman and Diu',
    value: 160,
    selected: [],
  },
  {
    label: 'Dehradun',
    value: 58,
    selected: [],
  },
  {
    label: 'Delhi',
    value: 36,
    selected: [],
  },
  {
    label: 'Delhi NCR',
    value: 1,
    selected: [36, 40, 41, 37, 38, 39],
  },
  {
    label: 'Dhaka',
    value: 106,
    selected: [],
  },
  {
    label: 'Doha',
    value: 98,
    selected: [],
  },
  {
    label: 'Dubai',
    value: 91,
    selected: [],
  },
  {
    label: 'Egypt',
    value: 113,
    selected: [],
  },
  {
    label: 'England',
    value: 170,
    selected: [],
  },
  {
    label: 'Ethiopia',
    value: 112,
    selected: [],
  },
  {
    label: 'EU',
    value: 28,
    selected: [],
  },
  {
    label: 'Faridabad',
    value: 40,
    selected: [],
  },
  {
    label: 'Gandhinagar',
    value: 55,
    selected: [],
  },
  {
    label: 'Germany',
    value: 168,
    selected: [],
  },
  {
    label: 'Ghaziabad',
    value: 41,
    selected: [],
  },
  {
    label: 'Goa',
    value: 13,
    selected: [],
  },
  {
    label: 'Greater Noida',
    value: 39,
    selected: [],
  },
  {
    label: 'Gujarat',
    value: 8,
    selected: [],
  },
  {
    label: 'Guntur',
    value: 77,
    selected: [],
  },
  {
    label: 'Gurgaon/Gurugram',
    value: 37,
    selected: [],
  },
  {
    label: 'Guwahati',
    value: 12,
    selected: [],
  },
  {
    label: 'Gwalior',
    value: 141,
    selected: [],
  },
  {
    label: 'Haridwar',
    value: 57,
    selected: [],
  },
  {
    label: 'Haryana',
    value: 16,
    selected: [],
  },
  {
    label: 'Himachal Pradesh',
    value: 153,
    selected: [],
  },
  {
    label: 'Hong Kong',
    value: 30,
    selected: [],
  },
  {
    label: 'Hosur',
    value: 71,
    selected: [],
  },
  {
    label: 'Hubli',
    value: 72,
    selected: [],
  },
  {
    label: 'Hyderabad',
    value: 4,
    selected: [],
  },
  {
    label: 'Imphal',
    value: 137,
    selected: [],
  },
  {
    label: 'Indore',
    value: 130,
    selected: [],
  },
  {
    label: 'Indonesia',
    value: 103,
    selected: [],
  },
  {
    label: 'Jaipur',
    value: 11,
    selected: [],
  },
  {
    label: 'Jalandhar',
    value: 46,
    selected: [],
  },
  {
    label: 'Jammu',
    value: 43,
    selected: [],
  },
  {
    label: 'Jammu & Kashmir',
    value: 42,
    selected: [],
  },
  {
    label: 'Jamnagar',
    value: 147,
    selected: [],
  },
  {
    label: 'Jamshedpur',
    value: 63,
    selected: [],
  },
  {
    label: 'Japan',
    value: 166,
    selected: [],
  },
  {
    label: 'Jharkhand',
    value: 20,
    selected: [],
  },
  {
    label: 'Jodhpur',
    value: 52,
    selected: [],
  },
  {
    label: 'Kabul',
    value: 92,
    selected: [],
  },
  {
    label: 'Kanpur',
    value: 133,
    selected: [],
  },
  {
    label: 'Karnataka',
    value: 31,
    selected: [],
  },
  {
    label: 'Kenya',
    value: 114,
    selected: [],
  },
  {
    label: 'Kerala',
    value: 17,
    selected: [],
  },
  {
    label: 'Kolkata',
    value: 5,
    selected: [],
  },
  {
    label: 'Kozhikode',
    value: 146,
    selected: [],
  },
  {
    label: 'Kuwait',
    value: 93,
    selected: [],
  },
  {
    label: 'Lakshadweep',
    value: 163,
    selected: [],
  },
  {
    label: 'London',
    value: 95,
    selected: [],
  },
  {
    label: 'Lucknow',
    value: 60,
    selected: [],
  },
  {
    label: 'Ludhiana',
    value: 48,
    selected: [],
  },
  {
    label: 'Madurai',
    value: 83,
    selected: [],
  },
  {
    label: 'Maharashtra',
    value: 9,
    selected: [],
  },
  {
    label: 'Malaysia',
    value: 27,
    selected: [],
  },
  {
    label: 'Manesar',
    value: 138,
    selected: [],
  },
  {
    label: 'Mangalore',
    value: 134,
    selected: [],
  },
  {
    label: 'Manipur',
    value: 124,
    selected: [],
  },
  {
    label: 'Meghalaya',
    value: 125,
    selected: [],
  },
  {
    label: 'Middle East',
    value: 25,
    selected: [],
  },
  {
    label: 'Mizoram',
    value: 122,
    selected: [],
  },
  {
    label: 'Mohali',
    value: 131,
    selected: [],
  },
  {
    label: 'MP',
    value: 10,
    selected: [],
  },
  {
    label: 'Mumbai',
    value: 2,
    selected: [],
  },
  {
    label: 'Muscat',
    value: 97,
    selected: [],
  },
  {
    label: 'Mysore',
    value: 73,
    selected: [],
  },
  {
    label: 'Nagaland',
    value: 128,
    selected: [],
  },
  {
    label: 'Nagpur',
    value: 66,
    selected: [],
  },
  {
    label: 'Nairobi',
    value: 115,
    selected: [],
  },
  {
    label: 'Nasik',
    value: 67,
    selected: [],
  },
  {
    label: 'Navi Mumbai',
    value: 68,
    selected: [],
  },
  {
    label: 'Nepal',
    value: 104,
    selected: [],
  },
  {
    label: 'Nigeria',
    value: 94,
    selected: [],
  },
  {
    label: 'Noida',
    value: 38,
    selected: [],
  },
  {
    label: 'Odisha',
    value: 18,
    selected: [],
  },
  {
    label: 'Oman',
    value: 96,
    selected: [],
  },
  {
    label: 'Others',
    value: 100000,
    selected: [],
  },
  {
    label: 'Pakistan',
    value: 110,
    selected: [],
  },
  {
    label: 'Panchkula',
    value: 142,
    selected: [],
  },
  {
    label: 'Panipat',
    value: 50,
    selected: [],
  },
  {
    label: 'Patiala',
    value: 47,
    selected: [],
  },
  {
    label: 'Patna',
    value: 61,
    selected: [],
  },
  {
    label: 'Philippines',
    value: 120,
    selected: [],
  },
  {
    label: 'Pondicherry',
    value: 85,
    selected: [],
  },
  {
    label: 'Pune',
    value: 7,
    selected: [],
  },
  {
    label: 'Punjab',
    value: 15,
    selected: [],
  },
  {
    label: 'Qatar',
    value: 99,
    selected: [],
  },
  {
    label: 'Raipur',
    value: 74,
    selected: [],
  },
  {
    label: 'Rajasthan',
    value: 33,
    selected: [],
  },
  {
    label: 'Rajkot',
    value: 80,
    selected: [],
  },
  {
    label: 'Ranchi',
    value: 62,
    selected: [],
  },
  {
    label: 'Remote',
    value: 132,
    selected: [],
  },
  {
    label: 'Riyadh',
    value: 102,
    selected: [],
  },
  {
    label: 'Salem',
    value: 149,
    selected: [],
  },
  {
    label: 'Saudi Arabia',
    value: 101,
    selected: [],
  },
  {
    label: 'Secunderabad',
    value: 144,
    selected: [],
  },
  {
    label: 'Shillong',
    value: 139,
    selected: [],
  },
  {
    label: 'Shimla',
    value: 152,
    selected: [],
  },
  {
    label: 'Sikkim',
    value: 158,
    selected: [],
  },
  {
    label: 'Siliguri',
    value: 143,
    selected: [],
  },
  {
    label: 'Silvassa',
    value: 135,
    selected: [],
  },
  {
    label: 'Singapore',
    value: 24,
    selected: [],
  },
  {
    label: 'Sonipat',
    value: 49,
    selected: [],
  },
  {
    label: 'South Africa',
    value: 117,
    selected: [],
  },
  {
    label: 'Sri Lanka',
    value: 111,
    selected: [],
  },
  {
    label: 'Srinagar',
    value: 44,
    selected: [],
  },
  {
    label: 'Surat',
    value: 54,
    selected: [],
  },
  {
    label: 'Switzerland',
    value: 169,
    selected: [],
  },
  {
    label: 'Tamil Nadu',
    value: 32,
    selected: [],
  },
  {
    label: 'Tanzania',
    value: 116,
    selected: [],
  },
  {
    label: 'Telangana',
    value: 35,
    selected: [],
  },
  {
    label: 'Thane',
    value: 69,
    selected: [],
  },
  {
    label: 'Tiruchirappalli',
    value: 148,
    selected: [],
  },
  {
    label: 'Tirupati',
    value: 150,
    selected: [],
  },
  {
    label: 'Tripura',
    value: 126,
    selected: [],
  },
  {
    label: 'Trivandrum/Thiruvananthapuram',
    value: 75,
    selected: [],
  },
  {
    label: 'Udaipur',
    value: 51,
    selected: [],
  },
  {
    label: 'UK',
    value: 23,
    selected: [],
  },
  {
    label: 'UP',
    value: 21,
    selected: [],
  },
  {
    label: 'US',
    value: 22,
    selected: [],
  },
  {
    label: 'Uttarakhand',
    value: 59,
    selected: [],
  },
  {
    label: 'Vadodara/Baroda',
    value: 56,
    selected: [],
  },
  {
    label: 'Vapi',
    value: 145,
    selected: [],
  },
  {
    label: 'Varanasi/Banaras',
    value: 81,
    selected: [],
  },
  {
    label: 'Vellore',
    value: 151,
    selected: [],
  },
  {
    label: 'Vijayawada',
    value: 76,
    selected: [],
  },
  {
    label: 'Vishakhapatnam/Vizag',
    value: 78,
    selected: [],
  },
  {
    label: 'Warangal',
    value: 82,
    selected: [],
  },
  {
    label: 'West Bengal',
    value: 129,
    selected: [],
  },
  {
    label: 'Zambia',
    value: 119,
    selected: [],
  },
  {
    label: 'Zimbabwe',
    value: 118,
    selected: [],
  },
];
export const hiristLocations = [
  {label: 'Bangalore', value: 3, selected: []},
  {label: 'Hyderabad', value: 4, selected: []},
  {label: 'Pune', value: 7, selected: []},
  {label: 'Chennai', value: 6, selected: []},
  {label: 'Mumbai', value: 2, selected: []},
  {label: 'Gurgaon/Gurugram', value: 37, selected: []},
  {label: 'Noida', value: 38, selected: []},
  {label: 'Delhi NCR', value: 1, selected: [36, 40, 41, 37, 38, 39, 1]},
  {label: 'Ahmedabad', value: 53, selected: []},
  {label: 'Navi Mumbai', value: 68, selected: []},
  {label: 'Delhi', value: 36, selected: []},
  {label: 'Kolkata', value: 5, selected: []},
  {label: 'Cochin/Kochi', value: 70, selected: []},
  {label: 'Coimbatore', value: 84, selected: []},
  {label: 'Trivandrum/Thiruvananthapuram', value: 75, selected: []},
  {label: 'Indore', value: 130, selected: []},
  {label: 'Jaipur', value: 11, selected: []},
  {label: 'Vishakhapatnam/Vizag', value: 78, selected: []},
  {label: 'Greater Noida', value: 39, selected: []},
  {label: 'Chandigarh', value: 14, selected: []},
  {label: 'Bhubaneshwar', value: 65, selected: []},
  {label: 'Nagpur', value: 66, selected: []},
  {label: 'Vadodara/Baroda', value: 56, selected: []},
  {label: 'Bhopal', value: 121, selected: []},
  {label: 'Surat', value: 54, selected: []},
  {label: 'Gandhinagar', value: 55, selected: []},
  {label: 'Mysore', value: 73, selected: []},
  {label: 'Faridabad', value: 40, selected: []},
  {label: 'Goa', value: 13, selected: []},
  {label: 'Lucknow', value: 60, selected: []},
  {label: 'Madurai', value: 83, selected: []},
  {label: 'Nasik', value: 67, selected: []},
  {label: 'Raipur', value: 74, selected: []},
  {label: 'Guwahati', value: 12, selected: []},
  {label: 'Dehradun', value: 58, selected: []},
  {label: 'Ghaziabad', value: 41, selected: []},
  {label: 'Patna', value: 61, selected: []},
];

export const sortBy = [
  {
    label: 'Date',
    value: 'date', //22
    selected: [],
  },
  {
    label: 'Relevance',
    value: 'relevance', //119
    selected: [],
  },
];
